import Http from "../Http";
import { API_BASE_URL } from "../Helper";

// Get notifications for current user
export function fetchUserNotifications(page = 1, limit = 10) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${API_BASE_URL}notifications/v1/get?page=${page}&limit=${limit}`)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

// Mark a single notification as read
export function markNotificationAsRead(notificationId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.put(`${API_BASE_URL}notifications/v1/mark-read/${notificationId}`, null)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

// Mark all notifications as read
export function markAllNotificationsAsRead() {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.put(`${API_BASE_URL}notifications/v1/mark-all-read`, null)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

// Get unread notification count
export function fetchUnreadNotificationCount() {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${API_BASE_URL}notifications/v1/unread-count`)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}
